import type { $Fetch } from 'ofetch';
import type { RoleGateway } from '@/application/port/out/RoleGateway';
import type { Role, Permission, RoleCommand } from '@/domain/model/Role';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** HTTP gateway de Roles + catálogo de Permissões. Authorities `identity:role:read|create|update|manage`. */
export class HttpRoleGateway implements RoleGateway {
  constructor(private readonly client: $Fetch) {}

  async list(): Promise<Role[]> {
    const res = await this.client<ApiResponse<Role[]>>('/api/v1/roles', { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async listPermissions(): Promise<Permission[]> {
    const res = await this.client<ApiResponse<Permission[]>>('/api/v1/permissions', { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: RoleCommand): Promise<Role> {
    const res = await this.client<ApiResponse<Role>>('/api/v1/roles', { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: RoleCommand): Promise<Role> {
    const res = await this.client<ApiResponse<Role>>(
      `/api/v1/roles/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async setPermissions(id: string, cmd: RoleCommand): Promise<Role> {
    const res = await this.client<ApiResponse<Role>>(
      `/api/v1/roles/${encodeURIComponent(id)}/permissions`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async deactivate(id: string): Promise<void> {
    // DELETE 204 No Content.
    await this.client(`/api/v1/roles/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
